import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { api } from "@/lib/api";

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then(({ data }) => setItems(data)); }, []);
  if (!items.length) return null;

  return (
    <section id="avis" className="py-24 lg:py-32 bg-[#141412]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="overline mb-4">Avis clients</div>
        <h2 className="font-serif-d text-4xl lg:text-6xl tracking-tight max-w-2xl mb-16">Ils nous font confiance.</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((t, i) => (
            <motion.figure key={t.id} data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="bg-[#161513] border border-[#F4F0EB]/8 p-8 lg:p-10 hover:border-[#C88D51]/40 transition-colors duration-500">
              <Quote className="w-6 h-6 text-[#C88D51] mb-5" />
              <blockquote className="font-cormorant text-2xl lg:text-[1.7rem] leading-snug text-[#F4F0EB] italic mb-6">“{t.text}”</blockquote>
              <figcaption>
                <div className="font-serif-d text-lg">{t.name}</div>
                {t.role && <div className="font-mono-a text-xs uppercase tracking-[0.2em] text-[#6E695E] mt-1">{t.role}</div>}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
